const inputMask = (input) => {
  const mask = /^(\d{3})\s*(\d{3})\s*(\d{4})$/;
  return input.replace(mask, '($1) $2-$3');
};

export const ssnInputMask = (input) => {
  return input.replace(/^(\d{3})(\d{2})(\d{4})$/, '$1-$2-$3');
};

export default inputMask;
